import { render, staticRenderFns } from "./TitleTrailer.vue?vue&type=template&id=ca9f457e&scoped=true&"
import script from "./TitleTrailer.vue?vue&type=script&lang=js&"
export * from "./TitleTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9f457e",
  null
  
)

export default component.exports